import { yupResolver } from "@hookform/resolvers/yup";
import { useContext, useEffect } from "react";
import * as yup from "yup";
import AuthContext from "../../Services/Auth";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import ApiWithAuth from "../../Config/Api/ApiWithAuth";
import LayoutAuth from "../../Layouts/Auth";
import ProfileCircleIcon from "../../Assets/Icons/linear/profile-circle.svg";
import LockIcon from "../../Assets/Icons/linear/lock.svg";
import Input from "../../Components/Input";
import Button from "../../Components/Button";

const schema = yup
	.object({
		email: yup.string().email().required(),
		password: yup.string().required(),
	})
	.required();

function LoginPage() {
	const { loading, login } = useContext(AuthContext);
	let navigate = useNavigate();

	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm({ resolver: yupResolver(schema) });

	const onSubmit = async (values, event) => {
		let response = await login(values.email, values.password);

		if (response?.status === 200) {
			setTimeout(() => {
				navigate("/master/users");
			}, 500);
		}
	};

	useEffect(() => {
		if (localStorage.getItem("role")) {
			navigate("/master/users");
		} else {
			navigate("/login");
		}
	}, []);

	return (
		<LayoutAuth>
			<div className="text-[42px] font-[600] my-5">Welcome</div>
			<form className="auth-form w-[350px]" onSubmit={handleSubmit(onSubmit)}>
				<Input
					icon={ProfileCircleIcon}
					placeholder="Username"
					required
					type="email"
					{...register("email")}
					errors={errors?.email?.message}
				/>
				<Input
					icon={LockIcon}
					placeholder="Password"
					required
					type="password"
					{...register("password")}
					errors={errors?.password?.message}
				/>
				<Button type="submit" disabled={loading} className="py-5">
					Login
				</Button>
			</form>
		</LayoutAuth>
	);
}

export default LoginPage;
